function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 0H2C.9 0 0 .9 0 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zM2 16V2h14v14H2zM3 3h2.57c0 1.42-1.15 2.58-2.57 2.58V3zm6 0H7.29c0 2.36-1.92 4.29-4.29 4.29V9c3.32 0 6-2.69 6-6zm-.86 9.73l3-3.87L15 14H3l3-3.85 2.14 2.58z",
  fill: "#000",
  fillOpacity: 0.54
});

var SvgIconSatellite = function SvgIconSatellite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "assets/icon-satellite.27559660.svg";
export { SvgIconSatellite as ReactComponent };